import Globe from 'react-globe.gl'
import { useEffect, useRef } from 'react'
import * as THREE from 'three'
import DatGui, {
  DatBoolean,
  DatColor,
  DatNumber,
  DatString,
} from 'react-dat-gui'

// custom globe material
// const globeMaterial = new THREE.MeshPhongMaterial()
// globeMaterial.bumpScale = 10
// new THREE.TextureLoader().load(
//   '//unpkg.com/three-globe/example/img/earth-water.png',
//   (texture) => {
//     globeMaterial.specularMap = texture
//     globeMaterial.specular = new THREE.Color('red')
//     globeMaterial.shininess = 90
//   }
// )

const GlobeHelper = () => {
  const globeEl = useRef<any>()
  const lightPosition = [1, 2, 2]

  useEffect(() => {
    if (!globeEl.current) return
    const directionalLight = globeEl.current
      .lights()
      .find((obj3d: any) => obj3d.type === 'DirectionalLight')
    if (directionalLight) {
      directionalLight.position.set(1, 0, 0)
      directionalLight.intensity = 1.25
    }
  }, [])

  return (
    <Globe
      ref={globeEl}
      animateIn={false}
      // globeMaterial={globeMaterial}
      showAtmosphere={true}
      atmosphereColor='rgba(200,200,200,0.0)'
      // atmosphereAltitude={0.2}
      backgroundColor='rgba(0,0,0,0)'
      globeImageUrl={require('./texture.png')}
      bumpImageUrl={require('./bump.png')}
      pathsData={[
        [
          [3, 100],
          [30, 120],
        ],
      ]}
      pathStroke={2}
      pathPointAlt={0.005}
    />
  )
}

export default GlobeHelper
